<aside class="sidebar"
       [ngClass]="{ 'sidebar-admin': isAdmin, 'sidebar-triagist': isTriagist, 'sidebar-super-user': isSuperUser }">
  <div>
    <header class="sidebar-header justify-content-center text-center mb-5">
      <div class="d-flex flex-column align-items-center gap-1">
        <svg-icon class="logo" [src]="'assets/image/logo_small.svg'"></svg-icon>
        <app-powered-by [variant]="'white'"></app-powered-by>
      </div>
    </header>

    <nav class="pt-md-5">
      @for (sideBarItem of menuItems(); track sideBarItem) {
        <a class="btn btn-side-navigation"
           [class.has-unreaded-content]="sideBarItem.isHolidaysAndLeaves && (hasUnreadedLeaveRequests())"
           [routerLink]="sideBarItem.link"
           [routerLinkActiveOptions]="{ exact: sideBarItem.routerLinkExact }"
           [routerLinkActive]="['active']">
          <div class="d-flex align-items-center gap-2">
            @if (sideBarItem?.icon) {
              <i-tabler [name]="sideBarItem.icon" class="icon"></i-tabler>
            }

            <span class="label d-inline d-lg-inline">{{ 'COMPONENT.SIDE_MENU.' + sideBarItem.title | translate }}</span>
          </div>
        </a>
      }
    </nav>
  </div>
  <div>
    <a type="button"
       class="btn btn-side-navigation"
       routerLink="/usefull-links"
       [routerLinkActiveOptions]="{ exact: true }"
       [routerLinkActive]="['active']">
      <div class="d-flex align-items-center gap-2">
        <i-tabler name="paperclip" class="icon"></i-tabler>
        <span class="label d-inline d-lg-inline">{{ 'COMPONENT.SIDE_MENU.USE_FULL_LINKS' | translate }}</span>
      </div>
    </a>
    <button type="button"
            class="btn btn-side-navigation"
            (click)="logOut()"
            [routerLinkActiveOptions]="{ exact: true }"
            [routerLinkActive]="['active']">
      <div class="d-flex align-items-center gap-2">
        <i-tabler name="logout-2" class="icon"></i-tabler>
        <span class="label d-inline d-lg-inline">{{ 'COMPONENT.SIDE_MENU.LOG_OUT' | translate }}</span>
      </div>
    </button>
    @if (language(); as selectedLanguage) {
      <div class="dropdown" dropdown container="body" placement="top left" [autoClose]="true"
      >
        <button type="button" class="btn language-selector" dropdownToggle>
          <div class="d-flex align-items-center gap-3">
            <i-tabler class="icon" name="world-pin"></i-tabler>
            {{ ('ENUM.LANGUAGE.' + (selectedLanguage | uppercase)) | translate }}
          </div>
          <i-tabler class="icon" name="chevron-down"></i-tabler>
        </button>
        <div class="dropdown-menu" *dropdownMenu>
          @for (language of LanguageVersion | enumToArray; track language) {
            <button type="button" class="dropdown-item" (click)="changeLanguage(language)"
                    [ngClass]="{'current-language': selectedLanguage === language }"
            >
              {{ ('ENUM.LANGUAGE.' + language | uppercase) | translate }}
            </button>
          }
        </div>
      </div>
    }
  </div>
</aside>
